module.exports = __webpack_public_path__ + "img/8.689785f9.png";